import { call, put, takeLatest, fork, all, delay } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParams } from '../utils/commonUtils';
import i18n from '../constants/initLng';
import { PATHS, SAGA_DELAY_TIMEOUT_1000 } from '../constants/Define';
import { get } from 'lodash';
import * as VinWonderActions from '../actions/vinWonderAction';
import * as VinWonderService from './../services/vinWonderService';
import history from '../helpers/history';


function* getListVinWonder() {
    yield takeLatest(Types.VIN_WONDER_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(VinWonderService.getVinWonders, params);
        yield put(VinWonderActions.dataVinWonderSuccess(result));
    }, errorHandleVinWonder(Types.VIN_WONDER_FAIL)))
}

function* checkVinWonder() {
    yield takeLatest(Types.VIN_WONDER_CHECK_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VinWonderService.checkVinWonder, action.serialNumber);
        yield put(VinWonderActions.checkVinWonderSuccess(result.data.data));
    }, errorHandleCheckVinWonder(Types.VIN_WONDER_FAIL)))
}

function* getVinWonderDetail() {
    yield takeLatest(Types.VIN_WONDER_GET_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VinWonderService.getVinWonderDetail, action.params.id);
        yield put(VinWonderActions.getUpdateVinWonderSuccess(result));
    }, errorHandleVinWonder(Types.VIN_WONDER_FAIL)))
}

function* createVinWonder() {
    yield takeLatest(Types.VIN_WONDER_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const vinWonder = action.params.data;
        const result = yield call(VinWonderService.createVinWonder, vinWonder);
        if(result.data.data){
            yield put({ type: Types.TAG_GROUP_SKU_MAPPING_UPDATE_ACTION, skuTags: { ...action.params.skuTags || {}, skuId: result.data.data } });
        }
        yield delay(SAGA_DELAY_TIMEOUT_1000)
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), vinWonder.name);
        history.push(PATHS.VIN_WONDER.LIST.path);
        history.go();
    }, errorHandleVinWonder(Types.VIN_WONDER_FAIL)))
}

function* updateVinWonder() {
    yield takeLatest(Types.VIN_WONDER_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const vinWonder = (action.params.data);
        yield call(VinWonderService.updateVinWonder, vinWonder);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), vinWonder.name);
        yield put({ type: Types.VIN_WONDER_UPDATE_SUCCESS });
        yield put({ type: Types.TAG_GROUP_SKU_MAPPING_UPDATE_ACTION, skuTags: { ...action.params.skuTags || {} } });
        yield delay(SAGA_DELAY_TIMEOUT_1000)
        history.push(PATHS.VIN_WONDER.LIST.path);
        history.go();
    }, errorHandleVinWonder(Types.VIN_WONDER_FAIL)))
}

function* deleteVinWonder() {
    yield takeLatest(Types.VIN_WONDER_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(VinWonderService.deleteVinWonder, action.params.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'));
        yield put({ type: Types.VIN_WONDER_LIST_ACTION, filters: action.params.PageIndex })
    }, errorHandleVinWonder(Types.VIN_WONDER_FAIL)))
}

function* getVinWonderSites() {
    yield takeLatest(Types.VIN_WONDER_SITES_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VinWonderService.getVinWonderSites);
        yield put(VinWonderActions.vinWonderSitesSuccess(result));
    }, errorHandleVinWonder(Types.VIN_WONDER_FAIL)))
}

function* getVinWonderTypes() {
    yield takeLatest(Types.VIN_WONDER_TYPES_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VinWonderService.getVinWonderTypes);
        yield put(VinWonderActions.vinWonderTypesSuccess(result));
    }, errorHandleVinWonder(Types.VIN_WONDER_FAIL)))
}

function* getVinWonderSessions() {
    yield takeLatest(Types.VIN_WONDER_SESSION_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VinWonderService.getVinWonderSessions, action.params);
        yield put(VinWonderActions.vinWonderSessionSuccess(result));
    }, errorHandleVinWonder(Types.VIN_WONDER_FAIL)))
}

function* getVinWonderZones() {
    yield takeLatest(Types.VIN_WONDER_ZONE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VinWonderService.getVinWonderZones, action.params);
        yield put(VinWonderActions.vinWonderZoneSuccess(result));
    }, errorHandleVinWonder(Types.VIN_WONDER_FAIL)))
}

// TRANSLATE
function* createVinWonderTranslate() {
    yield takeLatest(Types.VIN_WONDER_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(VinWonderService.createVinWonderTranslate, action.vinWonder);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.vinWonder.translate.languageName);
        yield put({ type: Types.VIN_WONDER_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.VIN_WONDER_GET_UPDATE_ACTION, params: { id: action.vinWonder.id } });
    }, errorHandleVinWonder(Types.VIN_WONDER_FAIL)))
}

function* updateVinWonderTranslate() {
    yield takeLatest(Types.VIN_WONDER_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(VinWonderService.updateVinWonderTranslate, action.vinWonder);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.vinWonder.translate.languageName);
        yield put({ type: Types.VIN_WONDER_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.VIN_WONDER_GET_UPDATE_ACTION, params: { id: action.vinWonder.id } });
    }, errorHandleVinWonder(Types.VIN_WONDER_FAIL)))
}

function* deleteVinWonderTranslate() {
    yield takeLatest(Types.VIN_WONDER_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(VinWonderService.deleteVinWonderTranslate, action.vinWonder.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.vinWonder.translate.languageName);
        yield put({ type: Types.VIN_WONDER_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.VIN_WONDER_GET_UPDATE_ACTION, params: { id: action.refreshParams.id } });
    }, errorHandleVinWonder(Types.VIN_WONDER_FAIL)))
}

function errorHandleCheckVinWonder(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        const code = get(e, 'errors[0].code');
        const message = get(e, 'errors[0].message') || i18n.t(`validation.statusCode.code.${code || 'UNDEFINED_ERROR'}`);
        const serialNumber = get(e, 'request.serialNumber');
        yield put(VinWonderActions.checkVinWonderSuccess(code ? false : undefined));
        yield put(VinWonderActions.checkVinWonderFailAction({ message: `* ${Func.checkUndefine(serialNumber)} ${code ? i18n.t(`validation.statusCode.code.${code}`) : message}` }));
        yield put({ type: errorActionType })
    }, 'vinWonder');
}

function errorHandleVinWonder(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'vinWonder');
}

export function* vinWonderSaga() {
    yield all([
        fork(getListVinWonder),
        fork(checkVinWonder),
        fork(createVinWonder),
        fork(deleteVinWonder),
        fork(getVinWonderDetail),
        fork(updateVinWonder),
        fork(createVinWonderTranslate),
        fork(updateVinWonderTranslate),
        fork(deleteVinWonderTranslate),
        fork(getVinWonderSites),
        fork(getVinWonderTypes),
        fork(getVinWonderSessions),
        fork(getVinWonderZones)

    ])
}
